import { useId, useState } from "react";
import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";

const LightTooltip = styled(({ className, ...props }: TooltipProps) => {
  const [open, setOpen] = useState(false);

  const id = useId();

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Escape") {
      event.preventDefault();
      setOpen(false);
    }
  };

  const handleFocus = () => {
    setOpen(true);
  };

  const handleBlur = () => {
    setOpen(false);
  };

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = (event: React.MouseEvent) => {
    const relatedTarget = event.relatedTarget as HTMLElement;
    if (!relatedTarget || !document.querySelector(`.${tooltipClasses.tooltip}`)?.contains(relatedTarget)) {
      setOpen(false);
    }
  };

  return (
    <>
    <Tooltip
      tabIndex={props.tabIndex || 0}
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocus}
      classes={{ popper: className }}
      PopperProps={{
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
      }}
      aria-label="tooltip"
      aria-describedby={`${props.id || id}-tooltip`}
    />
    <span id={`${props.id || id}-tooltip`} style={{ display: 'none' }} role="tooltip">
      {props.title}
    </span>
    </>
  );
})(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    fontFamily: 'Unimed-Sans',
    padding: '6px 18px'
  },
  [`& h1`]: {
    fontSize: 'inherit',
    fontWeight: 'bold',
  }
}));

export default LightTooltip;